import { LABEL_VALUE, LOGIN_VALUE, PATIENT_DATA } from "./storeTypes";
const initialState = {
  loginValues: [],
  labelValues: [],
  patientData:[]
};
const valueReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_VALUE:
      return {
        ...state,
        loginValues: [action.payload],
      };
    case LABEL_VALUE:
      return {
        ...state,
        labelValues: [action.payload],
      };
      case PATIENT_DATA:
        return {
          ...state,
          patientData: action.payload
        };
    default:
      return state;
  }
};
export default valueReducer;